import { useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Ticket } from "lucide-react";
import { toast } from "sonner";

export const WelcomePassRedeem = () => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const redeem = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/staff/welcome-passes/redeem", { code });
      toast.success(`Welcome Pass accepted — enjoy, ${data.child_name}!${data.allergies ? ` ⚠ Allergies: ${data.allergies}` : ""}`, { duration: 8000 });
      setCode("");
    } catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 rounded-2xl border border-gold/40 bg-gold/10 p-3" data-testid="welcome-pass-redeem">
      <Ticket className="w-5 h-5 text-gold" />
      <span className="text-sm font-semibold text-gold">Welcome Pass</span>
      <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="WP-XXXXXX" className="rounded-xl bg-white/10 border-white/20 text-white w-40 font-mono" data-testid="welcome-pass-code-input" />
      <Button size="sm" disabled={busy || code.trim().length < 4} onClick={redeem} className="rounded-full bg-gold text-navy font-bold hover:bg-gold/90" data-testid="welcome-pass-redeem-btn">Redeem</Button>
      <span className="text-[11px] text-white/50">Sat & Sun, 10 AM – 6 PM · until Oct 17</span>
    </div>
  );
};
